import { createAxiosInstance } from '@speechki-frontend/shared/axios';

const URL = process.env.VUE_APP_CRM_API_URL;
const axios = createAxiosInstance(URL);
const prefix = '/api/v1/flows';

export const fetchFlows = params => {
    return axios.get(`${prefix}/flows/`, { params });
};

export const fetchFlow = (id, params = {}) => {
    return axios.get(`${prefix}/flows/${id}/`, { params });
};

export const deleteFlow = (id, params = {}) => {
    return axios.delete(`${prefix}/flows/${id}/`, { params });
};

export const fetchFlowTransitions = async (id, params = {}) => {
    const { results: transitions = [] } = await axios.get(`${prefix}/transition_approval_metas/`, {
        params: {
            flow: id,
            ...params
        }
    });

    return transitions;
};

export const fetchFlowStates = async (id, params = {}) => {
    return axios.get(`${prefix}/flows/${id}/states/`, {
        flow: id,
        ...params
    });
};
